<div class="team-check-page">

  @if (loading) {
    <div class="loading-container">
      <div class="spinner"></div>
      <p>Cargando información...</p>
    </div>
  }
  @else {
    <div class="white-card">

      @if (imageNotReady) {
        <div class="warning-state">
          <div class="icon">⏳</div>
          <h2>Procesando Mapa de Detección</h2>
          <p>La IA está analizando el video y generando el mapa de jugadores. Por favor, espera unos minutos y vuelve a intentarlo.</p>
          <div class="warning-actions">
            <app-rfebm-secondary-button (onClick)="goBack()">Volver</app-rfebm-secondary-button>
            @if (isInternalUser) {
              <app-rfebm-primary-button (onClick)="openWatchWithoutTeams()">
                Ver video sin equipos
              </app-rfebm-primary-button>
            }
          </div>
        </div>
      }

      @else {
        <header class="page-header">
          <div class="header-top">
            <h1>Identificación de Equipos</h1>

            <button class="create-team-btn" (click)="openCreateModal()">
              <span class="icon">+</span> Nuevo Equipo
            </button>
          </div>
          <div class="video-title">
            <h2>{{ info?.video_title }}</h2>
          </div>
          <p class="subtitle">
            Haz clic en la imagen para ampliar. Asocia las cajas <span class="text-red">Rojas</span> y <span class="text-blue">Azules</span>.
          </p>
        </header>

        <div class="image-section">
          <div class="detection-map-container" (click)="toggleFullscreenImage()" title="Click para ampliar">
            <img [src]="info?.detection_image_url"
                 alt="Mapa Detección"
                 class="detection-img"
                 >
            <div class="zoom-hint">🔍 Ampliar</div>
          </div>
        </div>

        <div class="separator"></div>

        <div class="selection-grid">
          <div class="team-input-group">
            <div class="group-label red">
              <span class="dot"></span> Equipo recuadro Rojo (IA 1)
            </div>
            <app-selector
              [options]="teamsOptions"
              placeholder="Buscar equipo..."
              [allowSearch]="true"
              (valueChange)="onRedTeamSelected($event)">
            </app-selector>
          </div>

          <div class="team-input-group">
            <div class="group-label blue">
              <span class="dot"></span> Equipo recuadro Azul (IA 2)
            </div>
            <app-selector
              [options]="teamsOptions"
              placeholder="Buscar equipo..."
              [allowSearch]="true"
              (valueChange)="onBlueTeamSelected($event)">
            </app-selector>
          </div>
        </div>

        <footer class="page-actions">
          <app-rfebm-secondary-button (onClick)="goBack()">
            Cancelar
          </app-rfebm-secondary-button>

          @if (isInternalUser) {
            <app-rfebm-secondary-button (onClick)="openWatchWithoutTeams()">
              Ver video sin equipos
            </app-rfebm-secondary-button>
          }

          <app-rfebm-primary-button
            [isDisabled]="saving || !selectedRedTeamId || !selectedBlueTeamId"
            (onClick)="confirm()">
            {{ saving ? 'Guardando...' : 'Confirmar Asignación' }}
          </app-rfebm-primary-button>
        </footer>
      }
    </div>
  }

  @if (showCreateModal) {
    <div class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Crear Nuevo Equipo</h2>
          <button class="close-btn" (click)="closeCreateModal()">×</button>
        </div>
        <div class="modal-body">
          <p class="info-text">Se asignarán automáticamente los datos del video.</p>
          <div class="form-group">
            <label>Nombre *</label>
            <input type="text" [(ngModel)]="newTeamData.name" class="rfebm-input">
          </div>
          <div class="form-group">
            <label>Estadio</label>
            <input type="text" [(ngModel)]="newTeamData.stadium" class="rfebm-input">
          </div>
          <div class="form-group">
            <label>Localización</label>
            <input type="text" [(ngModel)]="newTeamData.location" class="rfebm-input">
          </div>
        </div>
        <div class="modal-footer">
          <app-rfebm-secondary-button (onClick)="closeCreateModal()">Cancelar</app-rfebm-secondary-button>
          <app-rfebm-primary-button
            [isDisabled]="creatingTeam || !newTeamData.name"
            (onClick)="createTeam()">
            {{ creatingTeam ? 'Creando...' : 'Crear' }}
          </app-rfebm-primary-button>
        </div>
      </div>
    </div>
  }

  @if (isFullscreenImage) {
    <div class="fullscreen-overlay" (click)="toggleFullscreenImage()">
      <div class="close-fs-btn">×</div>
      <img [src]="info?.detection_image_url" alt="Fullscreen Detección">
    </div>
  }

</div>
